import type { ChangeEvent } from 'react';

// Uppercase-on-input handler. Mirrors the inline pattern used by fields whose
// zod rule expects uppercase (passport series, trek id): rewrite the input's
// value to its upper-cased form and forward the event to the RHF field's
// onChange so the displayed value, the form state, and the validated payload
// stay aligned. Spread the registered field first, then override its onChange
// with this helper.
export const handleUppercaseChange =
  (onChange: (event: ChangeEvent<HTMLInputElement>) => unknown) =>
  (event: ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value.toUpperCase();
    event.target.value = value;
    void onChange(event);
  };
